import React from 'react';
import PropTypes from 'prop-types';
import { Button, FlexButtonGroup } from '@pattern-library/buttons';
import Checkbox, { CheckboxContainer } from '@pattern-library/checkbox';
import { ChevronLeftBoldIcon } from '@pattern-library/icon';
import OneTimeCode from '@pattern-library/one-time-code';

const propTypes = {
    backLinkProps: PropTypes.objectOf(PropTypes.string).isRequired,
    submitButtonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    showTrustDeviceInput: PropTypes.bool,
    trustDeviceInputProps: PropTypes.objectOf(PropTypes.string),
    verificationCodeInputProps: PropTypes.objectOf(PropTypes.string)
};

function OneTimePasscode(props) {
    const {
        backLinkProps,
        submitButtonProps,
        trustDeviceInputProps,
        showTrustDeviceInput,
        verificationCodeInputProps
    } = props;

    return (
        <div className="ul-login-form">
            <OneTimeCode
                autoFocus // eslint-disable-line jsx-a11y/no-autofocus
                {...verificationCodeInputProps}
            />
            {showTrustDeviceInput && (
                <CheckboxContainer
                    id={trustDeviceInputProps.id}
                    className="text--center"
                    hideLegend
                >
                    <Checkbox
                        id={trustDeviceInputProps.id}
                        label={trustDeviceInputProps.label}
                        value={trustDeviceInputProps.value}
                    />
                </CheckboxContainer>
            )}
            <FlexButtonGroup alignment="center" className="asc-mtb-4">
                <a
                    id={backLinkProps.id}
                    href={backLinkProps.link}
                    className="asc-btn asc-mtb-0 asc-btn--secondary"
                >
                    <ChevronLeftBoldIcon size="xxs" color="current" className="asc-mr-1" />
                    <span>{backLinkProps.text}</span>
                </a>
                <Button type="submit" className="asc-mtb-0" {...submitButtonProps} />
            </FlexButtonGroup>
        </div>
    );
}

OneTimePasscode.propTypes = propTypes;
export default OneTimePasscode;
